import { Component, Input, OnInit } from '@angular/core';
import { ICoverageDetails } from '../../core/interfaces/shared/ICoverageDetails.interface';


@Component({
  selector: 'app-coverage-detail',
  templateUrl: './coverage-detail.component.html',
  styleUrls: ['./coverage-detail.component.scss'],
})
export class CoverageDetailComponent implements OnInit {

  @Input() coverages: ICoverageDetails[];
  @Input() content: string;

  ngOnInit(): void {
  }
}
